import React, { createContext, useCallback, useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ComsContext = createContext({
  comsEnabled: true,
  loading: true,
  refreshComsAvailability: async () => {},
});

export const ComsProvider = ({ children }) => {
  const { user, platformFeatures, loadSession, loading } = useAuth();
  const comsEnabled = Boolean(user && platformFeatures?.comsEnabled === true);

  const refreshComsAvailability = useCallback(async () => {
    await loadSession();
  }, [loadSession]);

  useEffect(() => {
    window.addEventListener('coms-config-changed', refreshComsAvailability);
    return () => window.removeEventListener('coms-config-changed', refreshComsAvailability);
  }, [refreshComsAvailability]);

  return (
    <ComsContext.Provider value={{ comsEnabled, loading, refreshComsAvailability }}>
      {children}
    </ComsContext.Provider>
  );
};

export const useComsAvailability = () => useContext(ComsContext);
